import Overlay from 'common/components/core/Overlay'
import React, { Suspense } from 'react'
import { createPortal } from 'react-dom'
import type { PaymentCardPropsInterface } from '../PaymentCard'
import ModalCloseUi from './ui/ModalCloseUi'
import ModalContentUi from './ui/ModalContentUi'
import ModalUi from './ui/ModalUi'
import ModalWrapperUi from './ui/ModalWrapperUi'

export interface MercadoPagoCardPaymentModalPropsInterface
  extends PaymentCardPropsInterface {
  onClose: () => void
}

// PaymentCard uses @mercadopago/sdk-react which is client-only (ES modules)
// Using React.lazy with webpackMode: "eager" to avoid SSR issues while keeping it in the same chunk
const PaymentCard = React.lazy(() =>
  import(/* webpackMode: "eager" */ '../PaymentCard').then(
    ({ default: PaymentCard }) => ({
      default: PaymentCard,
    }),
  ),
)

export const MercadoPagoCardPaymentModal = ({
  amount,
  onClose,
  processPayment,
}: MercadoPagoCardPaymentModalPropsInterface) => {
  return createPortal(
    <>
      <ModalWrapperUi>
        <ModalUi>
          <ModalCloseUi onClick={onClose} />
          <ModalContentUi>
            <Suspense fallback={null}>
              <PaymentCard amount={amount} processPayment={processPayment} />
            </Suspense>
          </ModalContentUi>
        </ModalUi>
      </ModalWrapperUi>
      <Overlay dark />
    </>,
    document.getElementById('mercado-pago-dialog') as HTMLElement,
  )
}
